import { useEffect } from 'react'

import { tenantDisplayName, useTenantBranding } from '@/hooks/useTenantBranding'

export function DocumentBranding() {
  const { data: branding } = useTenantBranding()
  const storeName = tenantDisplayName(branding)
  const faviconUrl = branding?.favicon_url

  useEffect(() => {
    if (faviconUrl) {
      let link = document.querySelector<HTMLLinkElement>("link[rel='icon']")
      if (!link) {
        link = document.createElement('link')
        link.rel = 'icon'
        document.head.appendChild(link)
      }
      link.href = faviconUrl
    }
  }, [faviconUrl])

  useEffect(() => {
    document.title = `${storeName} · Yönetim`
  }, [storeName])

  return null
}
